import cx from "classnames";

import TabButton from "./TabButton";

import styles from "../../styles/Tabs.module.less";

type TabsProps = {
  className?: string;
  children: React.ReactNode;
};

const Tabs = ({ className = "", children }: TabsProps) => {
  return <div className={cx(className, styles.container)}>{children}</div>;
};

export default Object.assign(Tabs, { Button: TabButton });
